import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4861dfee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 0,
  for: "mediaInput"
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-take-pic" }, null, -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-videocam" }, null, -1))
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image-cd" }, null, -1))
const _hoisted_8 = {
  key: 4,
  for: "photoInput"
}
const _hoisted_9 = { class: "subtext" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_11 = { class: "subtext" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image" }, null, -1))
const _hoisted_14 = { class: "subtext" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))
const _hoisted_17 = { key: 1 }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-image-cd" }, null, -1))
const _hoisted_19 = { for: "photoInput" }
const _hoisted_20 = { class: "subtext" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "icon icon-upload-file" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_bottom_pop_up_item = _resolveComponent("bottom-pop-up-item")!
  const _component_app_bottom_pop_up = _resolveComponent("app-bottom-pop-up")!
  const _component_app_take_photo = _resolveComponent("app-take-photo")!
  const _component_DriveAddPhotos = _resolveComponent("DriveAddPhotos")!
  const _component_drive_add_menu_pop_up = _resolveComponent("drive-add-menu-pop-up")!
  const _component_DriveDesktopAddPhotos = _resolveComponent("DriveDesktopAddPhotos")!

  return (_ctx.mainStore.isMobile)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        (!_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_app_bottom_pop_up, {
              key: 0,
              onHide: _ctx.hidePopUp,
              class: "popUp-fixed",
              "hide-bottom-decoration": "",
              "hide-top-decoration": ""
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.title')), 1)
              ]),
              body: _withCtx(() => [
                (!_ctx.mainStore.isAndroid)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_2, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_3
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.picture')) + " CF ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 1,
                      onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.flutterOpenCamera && _ctx.flutterOpenCamera(...args)), ["prevent"])),
                      class: "link",
                      "data-type": "flutter"
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_4
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.picture')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 2,
                      for: "mediaInput",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_IMAGE)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_5
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.photo')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 3,
                      for: "mediaInput",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.CAMERA_VIDEO)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_6
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.take.video')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives((_openBlock(), _createElementBlock("input", {
                  ref: "mediaInputRef",
                  id: "mediaInput",
                  key: _ctx.mediaLoadedKey,
                  onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addMedia($event))),
                  accept: "image/png, image/jpg, image/jpeg, image/heic, image/bmp, video/*",
                  capture: "environment",
                  type: "file"
                }, null, 544)), [
                  [_vShow, false]
                ]),
                _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openAddPhotos }, {
                  icon: _withCtx(() => [
                    _hoisted_7
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                (!_ctx.mainStore.isAndroid)
                  ? (_openBlock(), _createElementBlock("label", _hoisted_8, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_10
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.$localize('upload.photos.popup.from.phone')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 5,
                      for: "photoInput",
                      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.GALLERY)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_12
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$localize('upload.files.popup.from.gallery')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 6,
                      onClick: _cache[5] || (_cache[5] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.flutterOpenImagePicker && _ctx.flutterOpenImagePicker(...args)), ["prevent"])),
                      "data-type": "flutter"
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_13
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.gallery')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.mainStore.isAndroid && !_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("label", {
                      key: 7,
                      for: "photoInput",
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE)))
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_15
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, _toDisplayString(_ctx.$localize('upload.files.popup.from.files')), 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                _withDirectives(_createElementVNode("input", {
                  onInput: _cache[7] || (_cache[7] = ($event: any) => (_ctx.uploadPhotos($event))),
                  id: "photoInput",
                  ref: "fileInput",
                  style: {"visibility":"hidden"},
                  type: "file",
                  accept: "image/png, image/jpg, image/jpeg, image/bmp, video/*",
                  multiple: ""
                }, null, 544), [
                  [_vShow, false]
                ]),
                (_ctx.mainStore.isFlutter)
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 8,
                      onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.flutterOpenFilePicker && _ctx.flutterOpenFilePicker(...args)), ["prevent"])),
                      "data-type": "flutter"
                    }, [
                      _createVNode(_component_bottom_pop_up_item, null, {
                        icon: _withCtx(() => [
                          _hoisted_16
                        ]),
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$localize('upload.files.popup.from.files')) + " ", 1)
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }, 8, ["onHide"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_app_take_photo, {
            ref: "appTakePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            "hide-options-list": "",
            "is-case-cropper": "",
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMultipleUpload,
            onOnRetake: _ctx.handleRetake,
            "z-index": "3500"
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
        ])),
        (_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_DriveAddPhotos, {
              key: 1,
              onClose: _ctx.closeAddPhotos
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
    : (_openBlock(), _createElementBlock("div", _hoisted_17, [
        (!_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_drive_add_menu_pop_up, {
              key: 0,
              class: "d-popup",
              onHide: _ctx.hidePopUp,
              "hide-bottom-decoration": "",
              "hide-top-decoration": "",
              desktopPopUpPosition: _ctx.popUpPosition
            }, {
              title: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.title')), 1)
              ]),
              body: _withCtx(() => [
                _createVNode(_component_bottom_pop_up_item, { onClick: _ctx.openAddPhotos }, {
                  icon: _withCtx(() => [
                    _hoisted_18
                  ]),
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$localize('upload.photos.popup.from.casedrive')) + " ", 1)
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createElementVNode("label", _hoisted_19, [
                  _createVNode(_component_bottom_pop_up_item, null, {
                    icon: _withCtx(() => [
                      _hoisted_21
                    ]),
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.$localize('upload.photos.popup.from.phone')), 1)
                    ]),
                    _: 1
                  }),
                  _createElementVNode("input", {
                    onInput: _cache[9] || (_cache[9] = ($event: any) => (_ctx.uploadPhotos($event))),
                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.setChooserType(_ctx.CHOOSER_TYPE.FILE))),
                    id: "photoInput",
                    ref: "fileInput",
                    style: {"visibility":"hidden"},
                    type: "file",
                    accept: "image/png, image/jpg, image/jpeg, image/bmp, video/*",
                    multiple: ""
                  }, null, 544)
                ])
              ]),
              _: 1
            }, 8, ["onHide", "desktopPopUpPosition"]))
          : _createCommentVNode("", true),
        (_openBlock(), _createBlock(_Teleport, { to: "#popup" }, [
          _createVNode(_component_app_take_photo, {
            ref: "appTakePhoto",
            image: _ctx.mediaToCrop,
            labels: _ctx.labels,
            "hide-options-list": "",
            "is-case-cropper": "",
            onOnCancel: _ctx.handleMediaCancel,
            onOnDone: _ctx.handleMultipleUpload,
            onOnRetake: _ctx.handleRetake,
            "z-index": "3500"
          }, null, 8, ["image", "labels", "onOnCancel", "onOnDone", "onOnRetake"])
        ])),
        (_ctx.isAddPhotosPopUp)
          ? (_openBlock(), _createBlock(_component_DriveDesktopAddPhotos, {
              key: 1,
              onClose: _ctx.closeAddPhotos
            }, null, 8, ["onClose"]))
          : _createCommentVNode("", true)
      ]))
}